import {
  INCIDENT_CODE_INCORRECT_ADDRESS,
  INCIDENT_CODE_NO_ANSWER_RE,
  INCIDENT_CODE_NO_EFFECTIVE,
  INCIDENT_CODE_REFUSED,
  SHIPPING_STATUS_CODES,
} from '../../common/constants'

export const STATUS_CODE_FILTER_ORDER = [
  SHIPPING_STATUS_CODES.manifested,
  SHIPPING_STATUS_CODES.collected,
  SHIPPING_STATUS_CODES.inTransit,
  SHIPPING_STATUS_CODES.delivering,
  SHIPPING_STATUS_CODES.pudo,
  SHIPPING_STATUS_CODES.delivered,
  SHIPPING_STATUS_CODES.returned,
  SHIPPING_STATUS_CODES.cancelled,
  'separator:pudo',
  SHIPPING_STATUS_CODES.depositPending,
  SHIPPING_STATUS_CODES.deposited,
]

export const INCIDENT_CODE_FILTER_ORDER = [
  INCIDENT_CODE_NO_ANSWER_RE,
  INCIDENT_CODE_INCORRECT_ADDRESS,
  INCIDENT_CODE_REFUSED,
  INCIDENT_CODE_NO_EFFECTIVE,
]
